// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { shareListModalStyles } from "@insite/content-library/Components/ShareListModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { TextFieldProps } from "@tps/MobiusOverrides/TextField/TextField";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

shareListModalStyles.recipientEmailTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
            position: absolute;
        `,
        tooltipClickable: css`
            position: absolute;
            margin-left: 5px;
        `,
    },
    typographyProps: {
        weight: "normal",
    },
};

shareListModalStyles.shareListTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
        `,
        tooltipContainer: css`
            width: 500px;
            ${xScreen("lte", "xs")} {
                width: 290px;
            }
        `,
        tooltipBody: css`
            padding: 5px;
        `,
    },
    typographyProps: {
        lineHeight: "16px",
    },
};

shareListModalStyles.yourNameTextField = {
    placeholder: translate("Your Name"),
} as TextFieldProps;

shareListModalStyles.recipientEmailAddressTextField = {
    placeholder: translate("Recipient Email"),
} as TextFieldProps;

shareListModalStyles.shareMessageTextArea = {
    cssOverrides: {
        inputSelect: css`
            resize: none;
        `,
    },
    placeholder: translate("Message"),
};

shareListModalStyles.inviteMessageTextArea = {
    cssOverrides: {
        inputSelect: css`
            resize: none;
        `,
    },
    placeholder: translate("Message"),
};

shareListModalStyles.buttonsContainer = {
    gap: 10,
    css: css`
        & ${GridOffset} {
            justify-content: space-between;
        }
    `,
};

shareListModalStyles.shareByOptionRadioGroup = {
    css: css`
        flex-direction: row;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex-direction: column;
                    `,
                ],
                "max",
            )}
    `,
};

shareListModalStyles.shareByEmailRadio = {
    css: css`
        & + & {
            margin-top: 0 !important;
            margin-left: 20px;
            ${xScreen("lte", "xs")} {
                margin-left: 0;
            }
        }
        input {
            margin-left: 0;
        }
    `,
};

shareListModalStyles.shareListOptionRadioGroup = shareListModalStyles.shareByOptionRadioGroup;

shareListModalStyles.sendCopyRadio = shareListModalStyles.shareByEmailRadio;

shareListModalStyles.container = { gap: 15 };
